export default __webpack_public_path__ + "static/media/half-mode.2f7f477e.svg";